import "./quick-filters";
/**
 * @name userEntryToNumber
 * @function
 * @returns {JSX}
 * @description Receives an input and checks if has "K" or "M", changing it to thousand or million respectevily
 */
export const userEntryToNumber = (textFromUser) => {
    const match = String(textFromUser).match(/^(\d+(\.\d+)?)([MkKGTmunpfa])$/);
    if (match) {
        const numericPart = parseFloat(match[1]);
        const suffix = match[3];

        switch (suffix) {
            case 'k':
            case 'K':
                return numericPart * 1e3;
            case 'M':
                return numericPart * 1e6;
            case 'G':
                return numericPart * 1e9;
            case 'T':
                return numericPart * 1e12;
            case 'm':
                return numericPart * 1e-3;
            case 'u':
                return numericPart * 1e-6;
            case 'n':
                return numericPart * 1e-9;
            case 'p':
                return numericPart * 1e-12;
            case 'f':
                return numericPart * 1e-15;
            case 'a':
                return numericPart * 1e-18;
            default:
                return textFromUser;
        }
    }

    return Number(textFromUser);
};

/**
 * @name filtersToHash
 * @function
 * @returns {JSX}
 * @description Creates the URL 
 */
export const filtersToHash = (selectedFilters, jsonData) => {
    let qstr = "";
    let addedColumns = null;
  
    switch (jsonData.quickFilterType) {
      case "bat":
        //Battery Chemistry
        if (selectedFilters['chem'] !== "") {
        //qstr += "!5380_"+selectedFilters['chem'];
        qstr = window._qfCommon.qsAddFilters(qstr, 5380, [selectedFilters['chem']]);
        }
    
        //vxmax-qb >= Vin Max
        if (selectedFilters['vmax'] !== "") {
            //qstr +="!5574_>="+selectedFilters['vmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vmax'], "max"]);
        }
    
        //iCharge >= Battery Charge
        if (selectedFilters['icharge'] !== "") {
            //qstr += "!5555_>="+selectedFilters['icharge'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5555, [selectedFilters['icharge'], "max"]);
        }
    
        //Solar Max Power Point
        if (selectedFilters['solar'] !== '' && selectedFilters['solar'] === 'on') {
            //qstr += "!5576_*Maximum Power*";
            qstr = window._qfCommon.qsAddFilters(qstr, 5576, "*Maximum Power*");
        }
    
        //Power Path
        if (selectedFilters['power_path'] !== '' && selectedFilters['power_path'] === 'on') {
            //qstr += "!5559_Linear PowerPath|Switching PowerPath"; 
            qstr = window._qfCommon.qsAddFilters(qstr, 5559, ["Linear PowerPath","Switching PowerPath"]);
        }
    
        //Buck
        if (selectedFilters['buck'] !== '' && selectedFilters['buck'] === 'on') {
            //qstr += "!5551_>0";
            qstr = window._qfCommon.qsAddFilters(qstr, 5551, ['0', "max"]);
        }
        //Boost
        if (selectedFilters['boost'] !== '' && selectedFilters['boost'] === 'on') {
            //qstr += "!5552_>0";
            qstr = window._qfCommon.qsAddFilters(qstr, 5552, ['0', "max"]);
        }
    
        //buckBoost
        if (selectedFilters['buckBoost'] !== '' && selectedFilters['buckBoost'] === 'on') {
            //qstr += "!5560_>0";
            qstr = window._qfCommon.qsAddFilters(qstr, 5560, ['0', "max"]);
        }
    
        if (addedColumns !== null && Array.isArray(addedColumns) && addedColumns.length > 0){
                qstr = window._qfCommon.qsAddColumns(qstr, addedColumns);
        }
        return qstr;
        break;
  
      case "batch":
        //Battery Chemistry
        if (selectedFilters['chem'] !== "") {
          //qstr += "!5380_"+frmInputControls['chem'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5380, [selectedFilters['chem']]);
        }
  
        //vxmax-qb >= Vin Max
        if (selectedFilters['vmax'] !== "") {
            //qstr +="!5574_>="+frmInputControls['vmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vmax'], "max"]);
        }
  
        //iCharge >= Battery Charge
        if (selectedFilters['icharge'] !== "") {
            //qstr += "!5555_>="+frmInputControls['icharge'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5555, [selectedFilters['icharge'], "max"]);
        }
  
        //Battery Charger
  
        //Solar Max Power Point
        if (selectedFilters['solar'] !== '' && selectedFilters['solar'] === 'on') {
            //qstr += "!5576_*Maximum Power*";
            qstr = window._qfCommon.qsAddFilters(qstr, 5576, "*Maximum Power*");
        }   
  
        if (addedColumns !== null && Array.isArray(addedColumns) && addedColumns.length > 0){
          qstr = window._qfCommon.qsAddColumns(qstr, addedColumns);
        }     
        return qstr;
        break;
      
      case "LDO":
        // Positive LDO
        var IOutMax;

        if (Number(selectedFilters['vout']) <= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) > 0 && Number(selectedFilters['vinmin']) > 0 && Number(selectedFilters['vinmax']) > 0) {           
            IOutMax = window._qfCommon.accMul(3, selectedFilters['iout']);

            if (IOutMax < .02) {
                IOutMax = .02;
            }

            //Vin Min <= Vin(min)
            // qstr += "!1032_<="+selectedFilters['vinmin'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
            //Vin Max of the part >= Vin(max)
            //qstr += "!1033_>="+selectedFilters['vinmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
            //Vout  of the part = Vout or Adj
           // qstr += "!5417_Adj|" + selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5417, ["Adj", selectedFilters['vout']]);
            //Output Current of the part >= Iout and <= Iout * 3
            //qstr += "!5349_" + selectedFilters['iout'] + ":" + IOutMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], IOutMax]);
            //Vout Min <= VOut
            // qstr += "!1105_<="+selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5347, ["min", selectedFilters['vout']]);
            //Vout Max of the part >= Vout
            // qstr += "!1034_>="+selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);

    
        }
        //Negative LDO
        if (Number(selectedFilters['vout']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) < 0 && Number(selectedFilters['vinmin']) < 0 && Number(selectedFilters['vinmax']) < 0) {

            IOutMax = window._qfCommon.accMul(20, Number(selectedFilters['iout']));

            if (IOutMax < .02) {
                IOutMax = .02;
            }

            //Vin Min >= Vin(min)
            // qstr += "!1032_<="+selectedFilters['vinmin'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
            //Vin Max of the part <= Vin(max)
            //qstr += "!1033_>="+selectedFilters['vinmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
            //Vout  of the part = Vout or Adj
            //qstr += "!5417_Adj|-Adj|" + selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5417, ["Adj","-Adj", selectedFilters['vout']]);
            //Output Current of the part >= Iout and <= Iout * 3
            //qstr += "!5349_" + selectedFilters['iout'] + ":" + IOutMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], IOutMax]);
            //Vout Min >= VOut
            // qstr += "!1034_>="+selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
            //Vout Max of the part <= Vout
            //qstr += "!1105_<="+selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5347, ["min", selectedFilters['vout']]);
        }
        
          return qstr;
          break;
    
      case "LED":
        let com = window._qfCommon;
        let intVoutMin;
        let intVoutMax;
        let intSwitchNeed;
        let intStringMax;
        let intStringMin;
        let outMin; 
        let outMax;
        let switchMax;

        //-------------------start-----------------
        let intRipple = 1.5;
        let intLEDMult = 10;
        intVoutMin = com.accMul(Number(selectedFilters['vledmin']), Number(selectedFilters['numled']));
        intVoutMax = com.accMul(Number(selectedFilters['vledmax']), Number(selectedFilters['numled']));

        if (intVoutMax < Number(selectedFilters['vinmin'])) {
            intSwitchNeed = Number(selectedFilters['istring']);
        }
        else {
            intSwitchNeed = com.accMul(com.accDiv(intVoutMax, Number(selectedFilters['vinmin'])), Number(selectedFilters['istring']));
        }

        if (Number(selectedFilters['numstring']) == 1) { intStringMin = 1; intStringMax = 1; }
        if (Number(selectedFilters['numstring']) == 2 || Number(selectedFilters['numstring'] == 3) || Number(selectedFilters['numstring'] == 4)) {
            intStringMin = Number(selectedFilters['numstring']);
            intStringMax = Number(selectedFilters['numstring']) + 1;
            intLEDMult = intLEDMult * 5
        }
        if (Number(selectedFilters['numstring']) > 4) {
            intStringMin = Number(selectedFilters['numstring']);
            intStringMax = 64
            intLEDMult = intLEDMult * 10
        }

        if (intSwitchNeed <= 0.05) { intLEDMult = intLEDMult * 2; }
        if (intSwitchNeed > 4) { intLEDMult = intLEDMult * 5; }
        if (intVoutMin >= 40 || Number(selectedFilters['vinmax']) > 36) { intLEDMult = intLEDMult * 10; }

        // Buck LED Driver
        if (intVoutMax <= Number(selectedFilters['vinmin'])) {

            outMax = com.accMul(intSwitchNeed, intLEDMult);

            //topology
           // qstr += "!5362_Buck";
            qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Buck");
            //Vin Min <= Vin(min)
           // qstr += "!1032_<=" + selectedFilters['vinmin'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
            //Vin Max of the part >= Vin(max)
           // qstr += "!1033_>=" + selectedFilters['vinmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
            //Outputs >= intStringMin and <=  intStringMax
            //qstr += "!5351_" + intStringMin + ":" + intStringMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5351, [intStringMin , intStringMax]);
            //Vout Max of the part >= Vout
            // qstr += "!1034_>=" + intVoutMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [intVoutMax, "max"]);
            //Output Current of the part >= Iout and <= Iout * intLEDMult
            //qstr += "!5349_" + intSwitchNeed + ":" + outMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5349, [intSwitchNeed , outMax]);
        }

        //Boost
        if (intVoutMin > Number(selectedFilters['vinmax'])) {

            outMax = com.accMul(com.accMul(intSwitchNeed, intLEDMult), intRipple);

            //topology
            //qstr += "!5362_Boost";
            qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Boost");
            //Vin Min <= Vin(min)
            // qstr += "!1032_<=" + selectedFilters['vinmin'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
            //Vin Max of the part >= Vin(max)
            //qstr += "!1033_>=" + selectedFilters['vinmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
            //Outputs >= intStringMin and <=  intStringMax
           // qstr += "!5351_" + intStringMin + ":" + intStringMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5351, [intStringMin, intStringMax]);
            //Vout Max of the part >= Vout
           // qstr += "!1034_>=" + intVoutMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [intVoutMax, "max"]);
            //Switch Current of the part >= switchmin and <= switchmax
            //qstr += "!5358_" + intSwitchNeed + ":" + outMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5358, [intSwitchNeed, outMax]);
        }

        //Buck-Boost or Sepic
        if (intVoutMin <= Number(selectedFilters['vinmax']) && intVoutMax > Number(selectedFilters['vinmin'])) {

            switchMax = com.accMul(com.accMul(intSwitchNeed, intLEDMult), intRipple);
            outMin = Number(selectedFilters['istring']);
            outMax = com.accMul(outMin, intLEDMult);

            //topology
           // qstr += "!5362_Buck-Boost|Sepic|Charge Pump";
            qstr = window._qfCommon.qsAddFilters(qstr, 5362, ["Buck-Boost","Sepic","Charge Pump"]);
            //Vin Min <= Vin(min)
            // qstr += "!1032_<=" + selectedFilters['vinmin-qld'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
            //Vin Max of the part >= Vin(max)
           // qstr += "!1033_>=" + selectedFilters['vinmax-qld'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
            //Outputs >= intStringMin and <=  intStringMax
            //qstr += "!5351_" + intStringMin + ":" + intStringMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5351, [intStringMin, intStringMax]);
            //Vout Max of the part >= Vout
            //qstr += "!5357_>=" + intVoutMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [intVoutMax, "max"]);
            //Switch Current of the part >= switchmin and <= switchmax
            //qstr += "!5358_" + intSwitchNeed + ":" + outMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5358, [outMin , outMax]);
            //Output Current of the part >= Iout and <= Iout * intLEDMult
            //qstr += "!5349_" + outMin + ":" + outMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5349, [outMin , outMax]);
        }
        //-----------------------------------------end -----------------------

        
        return qstr;
      break;
    
      case "pdac":
        // Slider values (always have min/maxes)
        qstr = window._qfCommon.qsAddFilters(qstr, 3062, [selectedFilters["chanmin"], selectedFilters["chanmax"]])
        qstr = window._qfCommon.qsAddFilters(qstr, 7, [selectedFilters["resmin"], selectedFilters["resmax"]])
  
        // Pulldown values (optional)
        if (selectedFilters["interface"] !== '')
           qstr = window._qfCommon.qsAddFilters(qstr, 5588, selectedFilters["interface"]);
        if (selectedFilters.dacType !== '')
          qstr = window._qfCommon.qsAddFilters(qstr, 4382, selectedFilters.dacType);
  
        return qstr;
      break;
      
      case "precision":
        // Slider values (always have min/maxes)
        qstr = window._qfCommon.qsAddFilters(qstr, 3062, [userEntryToNumber(selectedFilters["chanmin"]), userEntryToNumber(selectedFilters["chanmax"])])
        qstr = window._qfCommon.qsAddFilters(qstr, 7, [userEntryToNumber(selectedFilters["resmin"]), userEntryToNumber(selectedFilters["resmax"])])
        qstr = window._qfCommon.qsAddFilters(qstr, 1746, [userEntryToNumber(selectedFilters["spsmin"]), userEntryToNumber(selectedFilters["spsmax"])])
        
        // Pulldown values (optional)
        if (selectedFilters["architecture"] !== '')
            qstr = window._qfCommon.qsAddFilters(qstr, 4364, selectedFilters["architecture"]);
        if (selectedFilters["interface"] !== '')
            qstr = window._qfCommon.qsAddFilters(qstr, 4365, selectedFilters["interface"]);
        if (selectedFilters["inputType"] !== '')
            qstr = window._qfCommon.qsAddFilters(qstr, 4363, selectedFilters["inputType"]);
        return qstr;
        break;
      
      case "swreg":
        // // Buck 1
        if (Number(selectedFilters['vout']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) > 0) {
          let intBuckMult = window._qfCommon.accMul(1.5, 1);
  
          if (Number(selectedFilters['iout']) <= .1) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 10);
          } else if (selectedFilters['iout'] >= 4) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 8);
          }
  
          if (Number(selectedFilters['vinmax']) <= 5.5) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 1);
          } else if (Number(selectedFilters['vinmax']) <= 12) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 1);
          } else if (Number(selectedFilters['vinmax']) <= 36) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 1);
          } else if (Number(selectedFilters['vinmax']) <= 60) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 1.5);
          } else if (Number(selectedFilters['vinmax']) > 60) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 5);
          }
  
          outMax = window._qfCommon.accMul(Number(selectedFilters['iout']), intBuckMult);
  
          if (outMax < .025) {
              outMax = .025;
          }
  
          if (outMax > 240) {
              outMax = 240;
          }
  
          outMax = window._qfCommon.sigFigs(outMax, 3);
  
          //topology
          //qstr += "!5362_Buck";
          qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Buck");
  
  
          //Vin Min <= Vin(min)
          qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
  
          //Vin Max of the part >= Vin(max)
          qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
          //Vout Min of the part =< Vout
          qstr = window._qfCommon.qsAddFilters(qstr, 5347, ["min", selectedFilters['vout']]);
  
          //Vout Max of the part >= Vout
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
  
          //Output Current of the part >= Iout and <= Iout * intBuckMult
          qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], outMax]);   
  
        }
  
        // //Boost 1
        if (Number(selectedFilters['vout']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) > 0) {
          var intRippleSwreg = 1.66;
          var intBoostMult = 2;
          var intBBMult = 10;
          var intSwitchNeedSwreg = window._qfCommon.accMul(window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout']));
  
          if (intSwitchNeedSwreg < .5) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 3);
          } else if (intSwitchNeedSwreg >= 4 && intSwitchNeedSwreg <= 8) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 3);
          } else if (intSwitchNeedSwreg > 8) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 5);
          }
  
          if (Number(selectedFilters['vout']) > 12) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 2);
          }
          if (Number(selectedFilters['vout']) > 36) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 3);
          }
  
          var SwCrtMin = window._qfCommon.accMul(intRipple, intSwitchNeedSwreg);
          var SwCrtMax = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg, intBoostMult), intSwitchNeedSwreg);
          var OpCrtMax = window._qfCommon.accMul(intBBMult, Number(selectedFilters['iout']));
  
          if (SwCrtMax < .5) {
              SwCrtMax = .5;
          }
  
          //External Power Switch Boost
          if (window._qfCommon.domAccessors.select('#quickFilterPstId').textContent === '11485') {
              if (SwCrtMax < 10) {
                  SwCrtMax = 10;
              }
          }
  
          if (SwCrtMax > 60) {
              SwCrtMax = 60;
          }
  
          SwCrtMax = window._qfCommon.sigFigs(SwCrtMax, 3);
          SwCrtMin = window._qfCommon.sigFigs(SwCrtMin, 3);
          OpCrtMax = window._qfCommon.sigFigs(OpCrtMax, 3);
  
          //topology
          //qstr += "!5362_Boost|buckBoost";
          qstr = window._qfCommon.qsAddFilters(qstr, 5362, ["Boost", "buckBoost"]);
  
          //Vin Min <= Vin(min)
          qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
          //Vin Max of the part >= Vin(max)
          qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
          //Vout Max of the part >= Vout
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
          //Switch Current of the part >= SwCrtMin and <= SwCrtMax
          qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMin, SwCrtMax]);
  
  
          //Output Current of the part >= SwCrtMin and <= SwCrtMax
          qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], OpCrtMax]);
  
        }
  
        // //Inverter 1
        if (Number(selectedFilters['vout']) < 0) {
          var intRippleSwreg = 1.5;
          var intInvMult = 5;
  
          var SwCrtMinSwreg = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Math.abs(Number(selectedFilters['vout'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout']));
          var SwCrtMaxSwreg = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg, intInvMult), window._qfCommon.accMul(window._qfCommon.accAdd(1, window._qfCommon.accDiv(Math.abs(Number(selectedFilters['vout'])), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout'])));
  
          if (SwCrtMaxSwreg < .5) {
              SwCrtMaxSwreg = .5;
          }
  
          if (SwCrtMaxSwreg > 25) {
              SwCrtMaxSwreg = 25;
          }
  
          SwCrtMaxSwreg = window._qfCommon.sigFigs(SwCrtMaxSwreg, 3);
          SwCrtMinSwreg = window._qfCommon.sigFigs(SwCrtMinSwreg, 3);
  
          //topology
          //qstr += "!5362_Inverting";
          qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Inverting");
  
          //Vin Min <= Vin(min)
          qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
          //Vin Max of the part >= Vin(max)
          qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
  
          //Vout Max of the part >= abs(Vout)
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [Math.abs(Number(selectedFilters['vout'])), "max"]);
  
          qstr = window._qfCommon.qsAddFilters(qstr, 5369, [Number(selectedFilters['vinmax']) - Number(selectedFilters['vout']), "max"]);
  
  
          //Switch Current of the part >= SwCrtMin and <= SwCrtMax
          //qstr += "!5358_" + SwCrtMin + ":" + SwCrtMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMinSwreg, SwCrtMaxSwreg]);
  
        }
  
        // //buckBoost or Sepic 1
        if (Number(selectedFilters['vout']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) > 0) {
          var intRippleSwreg = 1.66;
          var intBBMult = 5;
          var intSwitchNeedSwreg = window._qfCommon.accMul(window._qfCommon.accDiv(1, window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout']));
  
          if (intSwitchNeedSwreg < .5) {
              intBBMult = window._qfCommon.accMul(intBBMult, 2);
          } else if (intSwitchNeedSwreg >= 4 && intSwitchNeedSwreg <= 8) {
              intBBMult = window._qfCommon.accMul(intBBMult, 2);
          } else if (intSwitchNeedSwreg >= 8) {
              intBBMult = window._qfCommon.accMul(intBBMult, 5);
          }
  
          var SwCrtMinSwreg = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg, window._qfCommon.accDiv(1, window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout']));
          var SwCrtMaxSwreg = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg, intBBMult), window._qfCommon.accMul(window._qfCommon.accDiv(1, window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout'])));
          var OpCrtMaxSwreg = window._qfCommon.accMul(intBBMult, Number(selectedFilters['iout']));
          var VswitchMaxSwreg = window._qfCommon.accDiv(Number(selectedFilters['vinmax']), Number(selectedFilters['vout']));
  
          if (SwCrtMaxSwreg < .5) {
              SwCrtMaxSwreg = .5;
          }
          if (OpCrtMaxSwreg < .25) {
              OpCrtMaxSwreg = .25;
          }
          if (SwCrtMaxSwreg > 60) {
              SwCrtMaxSwreg = 60;
          }
          if (OpCrtMaxSwreg > 25) {
              OpCrtMaxSwreg = 25;
          }
  
          SwCrtMaxSwreg = window._qfCommon.sigFigs(SwCrtMaxSwreg, 3);
          SwCrtMinSwreg = window._qfCommon.sigFigs(SwCrtMinSwreg, 3);
          OpCrtMaxSwreg = window._qfCommon.sigFigs(OpCrtMaxSwreg, 3);
  
          //topology
          //qstr += "!5362_buckBoost|SEPIC";
          qstr = window._qfCommon.qsAddFilters(qstr, 5362, ["Buck-Boost", "Sepic"]);
  
          //Vin Min <= Vin(min)
          qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
          //Vin Max of the part >= Vin(max)
          qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
          //Vout Min of the part <= Vout Min
          qstr = window._qfCommon.qsAddFilters(qstr, 5347, ["min", selectedFilters['vout']]);
  
          //Vout Max of the part >= Vout Max
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
          //Switch Current of the part >= SwCrtMin and <= SwCrtMax
          //qstr += "!5358_" + SwCrtMin + ":" + SwCrtMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMinSwreg, SwCrtMaxSwreg]);
  
          //Output Current of the part >= SwCrtMin and <= SwCrtMax
          qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], OpCrtMaxSwreg]);
  
          //Vswitch > Vin(max) + Vout
          //qstr += "!5369_>" + VswitchMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5369, [VswitchMaxSwreg, "max"]);
  
        }
  
        if (addedColumns !== null && Array.isArray(addedColumns) && addedColumns.length > 0){
                qstr = window._qfCommon.qsAddColumns(qstr, addedColumns);
        }
        return qstr;
        break;
            
      case "swreg2":
        let outMaxSwreg2, SwCrtMinSwreg2, SwCrtMaxSwreg2, OpCrtMaxSwreg2, VswitchMaxSwreg2;
  
      if (selectedFilters['iout']) {
          var NOut = 1;
      }
      if (selectedFilters['iout2']) {
          var NOut = 2;
      }
  
      // Buck 1
      if (Number(selectedFilters['vout']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) > 0) {
  
          var intBuckMult = window._qfCommon.accMul(1.5, NOut);
  
          if (Number(selectedFilters['iout']) <= .1) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 10);
          } else if (Number(selectedFilters['iout']) >= 4) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 8);
          }
  
          if (Number(selectedFilters['vinmax']) <= 5.5) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 1);
          } else if (Number(selectedFilters['vinmax']) <= 12) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 1);
          } else if (Number(selectedFilters['vinmax']) <= 36) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 1);
          } else if (Number(selectedFilters['vinmax']) <= 60) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 1.5);
          } else if (Number(selectedFilters['vinmax']) > 60) {
              intBuckMult = window._qfCommon.accMul(intBuckMult, 5);
          }
  
          intBuckMult = window._qfCommon.accMul(intBuckMult, NOut);
          outMaxSwreg2 = window._qfCommon.accMul(Number(selectedFilters['iout']), intBuckMult);
  
          if (outMaxSwreg2 < .025) {
              outMaxSwreg2 = .025;
          }
  
          if (outMaxSwreg2 > 240) {
              outMaxSwreg2 = 240;
          }
  
          outMaxSwreg2 = window._qfCommon.sigFigs(outMaxSwreg2, 3);
  
          //topology
          //qstr += "!5362_Buck";
          qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Buck");
  
          //Vin Min <= Vin(min)
          //qstr += "!5573_<=" + selectedFilters['vinmin'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
          //Vin Max of the part >= Vin(max)
          //qstr += "!5574_>=" + selectedFilters['vinmax'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
          //Vout Min of the part =< Vout
          //qstr += "!5347_<=" + selectedFilters['vout'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5347, ["min", selectedFilters['vout']]);
  
          //Vout Max of the part >= Vout
          //qstr += "!5357_>=" + selectedFilters['vout'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
          //Output Current of the part >= Iout and <= Iout * intBuckMult
          //qstr += "!5349_" + selectedFilters['iout'] + ":" + outMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], outMaxSwreg2]);
  
          //Number of outputs > NOut
          if (NOut > 1) {
              //qstr += "!5351_>=" + NOut;
              qstr = window._qfCommon.qsAddFilters(qstr, 5351, [NOut, "max"]);
          }
      }
  
      //Boost 1
      if (Number(selectedFilters['vout']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) > 0) {
          var intRippleSwreg2 = 1.66;
          var intBoostMult = 2;
          var intSwitchNeedSwreg2 = window._qfCommon.accMul(window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout']));
  
          if (intSwitchNeedSwreg2 < .5) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 3);
          } else if (intSwitchNeedSwreg2 >= 4 && intSwitchNeedSwreg2 <= 8) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 3);
          } else if (intSwitchNeedSwreg2 > 8) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 5);
          }
  
          if (Number(selectedFilters['vout']) > 12) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 2);
          }
          if (Number(selectedFilters['vout']) > 36) {
              intBoostMult = window._qfCommon.accMul(intBoostMult, 3);
          }
  
          intBoostMult = window._qfCommon.accMul(intBoostMult, NOut);
  
          SwCrtMinSwreg2 = window._qfCommon.accMul(intRippleSwreg2, intSwitchNeedSwreg2);
          SwCrtMaxSwreg2 = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg2, intBoostMult), intSwitchNeedSwreg2);
          if (SwCrtMaxSwreg2 < .5) {
              SwCrtMaxSwreg2 = .5;
          }
        
          //if (category_id == '1115') {
          if (window._qfCommon.domAccessors.select('#quickFilterPstId').textContent === '11485') {
            if (SwCrtMaxSwreg2 < 10) {
                SwCrtMaxSwreg2 = 10;
            }
          }
  
          if (SwCrtMaxSwreg2 > 60) {
              SwCrtMaxSwreg2 = 60;
          }
  
          SwCrtMaxSwreg2 = window._qfCommon.sigFigs(SwCrtMaxSwreg2, 3);
          SwCrtMinSwreg2 = window._qfCommon.sigFigs(SwCrtMinSwreg2, 3);
  
          //topology
          //qstr += "!5362_Boost";
          qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Boost");
  
          //Vin Min <= Vin(min)
          //qstr += "!5573_<=" + selectedFilters['vinmin'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
          //Vin Max of the part >= Vin(max)
          //qstr += "!5574_>=" + selectedFilters['vinmax'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
          //Vout Max of the part >= Vout
          //qstr += "!5357_>=" + selectedFilters['vout'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
          //Switch Current of the part >= SwCrtMin and <= SwCrtMax
          //qstr += "!5358_" + SwCrtMin + ":" + SwCrtMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMinSwreg2, SwCrtMaxSwreg2]);
  
          //Number of outputs > NOut
          if (NOut > 1) {
              //qstr += "!5351_>=" + NOut;
              qstr = window._qfCommon.qsAddFilters(qstr, 5351, [NOut, "max"]);
          }
      }
  
      //Inverter 1
      if (Number(selectedFilters['vout']) < 0) {
          var intRippleSwreg2 = 1.5;
          var intInvMultSwreg2 = 5;
  
          intInvMultSwreg2 = window._qfCommon.accMul(intInvMult, NOut);
          SwCrtMinSwreg2 = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg2, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Math.abs(Number(selectedFilters['vout'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout']));
          SwCrtMaxSwreg2 = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg2, intInvMultSwreg2), window._qfCommon.accMul(window._qfCommon.accAdd(1, window._qfCommon.accDiv(Math.abs(Number(selectedFilters['vout'])), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout'])));
  
          if (SwCrtMaxSwreg2 < .5) {
              SwCrtMaxSwreg2= .5;
          }
  
          if (SwCrtMaxSwreg2 > 25) {
              SwCrtMaxSwreg2 = 25;
          }
  
          SwCrtMaxSwreg2 = window._qfCommon.sigFigs(SwCrtMaxSwreg2, 3);
          SwCrtMinSwreg2 = window._qfCommon.sigFigs(SwCrtMinSwreg2, 3);
  
          //topology
          //qstr += "!5362_Inverting";
          qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Inverting");
  
          //Vin Min <= Vin(min)
          //qstr += "!5573_<=" + selectedFilters['vinmin'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
          //Vin Max of the part >= Vin(max)
          //qstr += "!5574_>=" + selectedFilters['vinmax'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
          //Vout Max of the part >= abs(Vout)
          //qstr += "!5357_>=" + Math.abs(selectedFilters['vout']);
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [Math.abs(selectedFilters['vout']), "max"]);
  
          //Vswitch Max of the part >= selectedFilters['vinmax'] - selectedFilters['vout']
          //qstr += "!5369_>=" + (selectedFilters['vinmax'] - selectedFilters['vout']);
          qstr = window._qfCommon.qsAddFilters(qstr, 5369, [selectedFilters['vinmax'] - selectedFilters['vout'], "max"]);
  
          //Switch Current of the part >= SwCrtMin and <= SwCrtMax
          //qstr += "!5358_" + SwCrtMin + ":" + SwCrtMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMinSwreg2, SwCrtMaxSwreg2]);
  
          //Number of outputs > NOut
          if (NOut > 1) {
              //qstr += "!5351_>=" + NOut;
              qstr = window._qfCommon.qsAddFilters(qstr, 5351, [NOut, "max"]);
          }
      }
  
      //buckBoost or Sepic 1
      if (Number(selectedFilters['vout']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) > 0) {
          var intRippleSwreg2 = 1.66;
          var intBBMult = 5;
          var intSwitchNeedSwreg2 = window._qfCommon.accMul(window._qfCommon.accAdd(1, window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout']));
  
          if (intSwitchNeedSwreg2 < .5) {
              intBBMult = window._qfCommon.accMul(intBBMult, 2);
          } else if (intSwitchNeedSwreg2 >= 4 && intSwitchNeedSwreg2 <= 8) {
              intBBMult = window._qfCommon.accMul(intBBMult, 2);
          } else if (intSwitchNeedSwreg2 >= 8) {
              intBBMult = window._qfCommon.accMul(intBBMult, 5);
          }
  
          intBBMult = window._qfCommon.accMul(intBBMult, NOut);
          SwCrtMinSwreg2 = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg2, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout']));
          SwCrtMaxSwreg2 = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg2, intBBMult), window._qfCommon.accMul(window._qfCommon.accAdd(1, window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout'])));
          OpCrtMaxSwreg2 = window._qfCommon.accMul(intBBMult, Number(selectedFilters['iout']));
          VswitchMaxSwreg2 = window._qfCommon.accAdd(Number(selectedFilters['vinmax']), Number(selectedFilters['vout']));
  
          if (SwCrtMaxSwreg2 < .5) {
              SwCrtMaxSwreg2 = .5;
          }
          if (OpCrtMaxSwreg2 < .25) {
              OpCrtMaxSwreg2 = .25;
          }
          if (SwCrtMaxSwreg2 > 60) {
              SwCrtMaxSwreg2 = 60;
          }
          if (OpCrtMaxSwreg2 > 25) {
              OpCrtMaxSwreg2 = 25;
          }
  
          SwCrtMaxSwreg2 = window._qfCommon.sigFigs(SwCrtMaxSwreg2, 3);
          SwCrtMinSwreg2 = window._qfCommon.sigFigs(SwCrtMinSwreg2, 3);
          OpCrtMaxSwreg2 = window._qfCommon.sigFigs(OpCrtMaxSwreg2, 3);
  
          //topology
          //qstr += "!5362_buckBoost|SEPIC";
          qstr = window._qfCommon.qsAddFilters(qstr, 5362, ["Sepic", "buckBoost"]);
  
          //Vin Min <= Vin(min)
          //qstr += "!5573_<=" + selectedFilters['vinmin'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
          //Vin Max of the part >= Vin(max)
          //qstr += "!5574_>=" + selectedFilters['vinmax'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
          //Vout Min of the part <= Vout Min
          //qstr += "!5347_<=" + selectedFilters['vout'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5347, ["min", selectedFilters['vout']]);
  
          //Vout Max of the part >= Vout Max
          //qstr += "!5357_>=" + selectedFilters['vout'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
          //Switch Current of the part >= SwCrtMin and <= SwCrtMax
          //qstr += "!5358_" + SwCrtMin + ":" + SwCrtMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMinSwreg2, SwCrtMaxSwreg2]);
  
          //Output Current of the part >= SwCrtMin and <= SwCrtMax
          //qstr += "!5349_" + selectedFilters['iout'] + ":" + OpCrtMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], OpCrtMaxSwreg2]);
  
          //Vswitch > Vin(max) + Vout
          //qstr += "!5369_>" + VswitchMax;
          qstr = window._qfCommon.qsAddFilters(qstr, 5369, [VswitchMaxSwreg2, "max"]);
  
          //Number of outputs > NOut
          if (NOut > 1) {
              //qstr += "!5351_>=" + NOut;
              qstr = window._qfCommon.qsAddFilters(qstr, 5351, [NOut, "max"]);
          }
  
      }
  
      // Buck 2
      if (Number(selectedFilters['vout2']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout2']) > 0) {
  
          //topology
          //qstr += "!5363_Buck|LDO";
          qstr = window._qfCommon.qsAddFilters(qstr, 5363, ["Buck", "LDO"]);
  
          //Vout Min of the part =< Vout
          //qstr += "!5372_<=" + selectedFilters['vout2'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5572, ["min", selectedFilters['vout2']]);
  
          //Vout Max of the part >= Vout
          //qstr += "!5374_>=" + selectedFilters['vout2'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], "max"]);
  
          //Output Current of the part >= Iout
          //qstr += "!5371_>=" + selectedFilters['iout2'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5371, [selectedFilters['iout2'], "max"]);
      }
  
  
      //Boost 2
      if (Number(selectedFilters['vout2']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout2']) > 0) {
          var intRippleSwreg2 = 1.5;
          var intSwitchNeedSwreg2 = window._qfCommon.accMul(window._qfCommon.accDiv(Number(selectedFilters['vout2']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout2']));
          SwCrtMinSwreg2 = window._qfCommon.accMul(intRippleSwreg2, intSwitchNeedSwreg2);
          SwCrtMinSwreg2 = window._qfCommon.sigFigs(SwCrtMinSwreg2, 3);
  
          //topology
          //qstr += "!5363_Boost";
          qstr = window._qfCommon.qsAddFilters(qstr, 5363, "Boost");
  
          //Vout Max of the part >= Vout
          //qstr += "!5374_>=" + selectedFilters['vout2'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], "max"]);
  
          //Switch Current of the part >= SwCrtMin
          //qstr += "!5561_>=" + SwCrtMin;
          qstr = window._qfCommon.qsAddFilters(qstr, 5561, [SwCrtMinSwreg2, "max"]);
      }
  
      //Inverter 2
      if (Number(selectedFilters['vout2']) < 0) {
          var intRippleSwreg2 = 1.5;
          SwCrtMinSwreg2 = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg2, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Math.abs(Number(selectedFilters['vout2'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout2']));
          SwCrtMinSwreg2 = window._qfCommon.sigFigs(SwCrtMinSwreg2, 3);
  
          //topology
          //qstr += "!5363_Inverting";
          qstr = window._qfCommon.qsAddFilters(qstr, 5363, "Inverting");
  
          //Vout Max of the part >= abs(Vout)
          //qstr += "!5357_>=" + Math.abs(selectedFilters['vout2']);
          qstr = window._qfCommon.qsAddFilters(qstr, 5357, [Math.abs(selectedFilters['vout2']), "max"]);
  
          //Vswitch Max of the part >= selectedFilters['vinmax'] - selectedFilters['vout']
          //qstr += "!5369_>=" + (selectedFilters['vinmax'] - selectedFilters['vout2']);
          qstr = window._qfCommon.qsAddFilters(qstr, 5369, [Number(selectedFilters['vinmax']) - Number(selectedFilters['vout2']), "max"]);
  
          //Switch Current of the part >= SwCrtMin
          //qstr += "!5561_>=" + SwCrtMin;
          qstr = window._qfCommon.qsAddFilters(qstr, 5561, [SwCrtMinSwreg2, "max"]);
      }
  
      //buckBoost or Sepic 2
      if (Number(selectedFilters['vout2']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout2']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout2']) > 0) {
          var intRippleSwreg2 = 1.5;
          SwCrtMinSwreg2 = window._qfCommon.accMul(window._qfCommon.accMul(intRippleSwreg2, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Number(selectedFilters['vout2']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout2']));
          SwCrtMinSwreg2 = window._qfCommon.sigFigs(SwCrtMinSwreg2, 3);
  
          //topology
          //qstr += "!5363_buckBoost|Sepic";
          qstr = window._qfCommon.qsAddFilters(qstr, 5363, ["Buck-Boost", "Sepic"]);
  
          //Vout Min of the part <= Vout Min
          //qstr += "!5372_<=" + selectedFilters['vout2'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5372, ["min", selectedFilters['vout2']]);
  
          //Vout Max of the part >= Vout Max
          //qstr += "!5374_>=" + selectedFilters['vout2'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], "max"]);
  
          //Switch Current of the part >= SwCrtMin
          //qstr += "!5561_>=" + SwCrtMin;
          qstr = window._qfCommon.qsAddFilters(qstr, 5561, [SwCrtMinSwreg2, "max"]);
  
          //Output Current of the part >= SwCrtMin
          //qstr += "!5371_>=" + selectedFilters['iout'];
          qstr = window._qfCommon.qsAddFilters(qstr, 5371, [selectedFilters['iout'], "max"]);
      }
  
      if (addedColumns !== null && Array.isArray(addedColumns) && addedColumns.length > 0){
              qstr = window._qfCommon.qsAddColumns(qstr, addedColumns);
      }
      return qstr;
        break;
              
      case "swregbig":
        let common = window._qfCommon;
        let outMaxSwregbig, SwCrtMinSwregbig, SwCrtMaxSwregbig, OpCrtMaxSwregbig, VswitchMaxSwregbig;
  
  
        // Checkbox fields with possible values
        // - Yes: must be
        // - No: must not be
        // - on: selects all
        // - [anything else]: only non-Yes, non-NO
        if (selectedFilters["mono"]) {
            qstr = common.qsAddFilters(qstr, 5345, "Yes"); // 1038
        }
        else if (selectedFilters["Module"]) {
            qstr = common.qsAddFilters(qstr, 5352, "Yes"); // 2220
        }
        if (selectedFilters["sync"]) {
            qstr = common.qsAddFilters(qstr, 5344, "Yes"); // 1036
        }
  
        /**
         * Below ported from PHP file (swregbig.php)
         * However, this function (GetQuickSearchURL) is only called if there
         * were no basic errors, so the error check (from PHP version) 
         * is omitted.
         */
  
        var NOut = selectedFilters['iout3'] ? 3 : selectedFilters['iout2'] ? 2 : 1;
  
        /**
         * Buck 1
         */
        if (Number(selectedFilters['vout']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) > 0) {
  
            var intBuckMult = common.accMul(1.5, NOut);
  
            if (Number(selectedFilters['iout']) <= .1) {
                intBuckMult = common.accMul(intBuckMult, 10);
            } else if (Number(selectedFilters['iout']) >= 4) {
                intBuckMult = common.accMul(intBuckMult, 8);
            }
  
            if (Number(selectedFilters['vinmax']) <= 5.5) {
                intBuckMult = common.accMul(intBuckMult, 1);
            } else if (Number(selectedFilters['vinmax']) <= 12) {
                intBuckMult = common.accMul(intBuckMult, 1);
            } else if (Number(selectedFilters['vinmax']) <= 36) {
                intBuckMult = common.accMul(intBuckMult, 1);
            } else if (Number(selectedFilters['vinmax']) <= 60) {
                intBuckMult = common.accMul(intBuckMult, 1.5);
            } else if (Number(selectedFilters['vinmax']) > 60) {
                intBuckMult = common.accMul(intBuckMult, 5);
            }
  
            outMaxSwregbig = common.accMul(Number(selectedFilters['iout']), intBuckMult);
  
            if (outMaxSwregbig < .025) {
                outMaxSwregbig = .025;
            }
  
            if (outMaxSwregbig > 240) {
                outMaxSwregbig = 240;
            }
  
            outMaxSwregbig = common.sigFigs(outMaxSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5362, "Buck"); // 1646
            // Vin Min <= Vin(min)
            qstr = common.qsAddFilters(qstr, 5573, ['min', selectedFilters['vinmin']]); // 1032
            // Vin Max of the part >= Vin(max)
            qstr = common.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], 'max']); // 1033
            // Vout Min of the part =< Vout
            qstr = common.qsAddFilters(qstr, 5347, ['min', selectedFilters['vout']]); // 1105
            // Vout Max of the part >= Vout
            qstr = common.qsAddFilters(qstr, 5357, [selectedFilters['vout'], 'max']); // 1034
            //Output Current of the part >= Iout and <= Iout * intBuckMult
            qstr = common.qsAddFilters(qstr, 5349, [selectedFilters['iout'], outMaxSwregbig]); // 1107
            // Number of outputs > NOut
            if (NOut > 1) {
                qstr = common.qsAddFilters(qstr, 5351, [NOut, 'max']); // 2167
            }
  
        }
  
        /**
         * Boost 1
         */
        if (Number(selectedFilters['vout']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) > 0) {
            var intRippleSwregbig = 1.66;
            var intBoostMultSwregbig = common.accMul(2, NOut);
            var intBBMultSwregbig = 10;
            var intSwitchNeedSwregbig = common.accMul(common.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout']));
  
            if (intSwitchNeedSwregbig < .5) {
                intBoostMultSwregbig = common.accMul(intBoostMultSwregbig, 3);
            } else if (intSwitchNeedSwregbig >= 4 && intSwitchNeedSwregbig <= 8) {
                intBoostMultSwregbig = common.accMul(intBoostMultSwregbig, 3);
            } else if (intSwitchNeedSwregbig > 8) {
                intBoostMultSwregbig = common.accMul(intBoostMultSwregbig, 5);
            }
  
            if (Number(selectedFilters['vout']) > 12) {
                intBoostMultSwregbig = common.accMul(intBoostMultSwregbig, 2);
            }
            if (selectedFilters['vout'] > 36) {
                intBoostMultSwregbig = common.accMul(intBoostMultSwregbig, 3);
            }
  
            SwCrtMinSwregbig = common.accMul(intRippleSwregbig, intSwitchNeedSwregbig);
            SwCrtMaxSwregbig = common.accMul(common.accMul(intRippleSwregbig, intBoostMultSwregbig), intSwitchNeedSwregbig);
            OpCrtMaxSwregbig = common.accMul(intBBMultSwregbig, Number(selectedFilters['iout']));
  
            if (SwCrtMaxSwregbig < .5) {
                SwCrtMaxSwregbig = .5;
            }

            if (SwCrtMaxSwregbig < 10) {
                SwCrtMaxSwregbig = 10;
            }          
  
            if (SwCrtMaxSwregbig > 60) {
                SwCrtMaxSwregbig = 60;
            }
  
            SwCrtMaxSwregbig = common.sigFigs(SwCrtMaxSwregbig, 3);
            SwCrtMinSwregbig = common.sigFigs(SwCrtMinSwregbig, 3);
            OpCrtMaxSwregbig = common.sigFigs(OpCrtMaxSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5362, ["Boost", "buckBoost"]); // 1646
            // Vin Min <= Vin(min)
            qstr = common.qsAddFilters(qstr, 5573, ['min', selectedFilters['vinmin']]); // 1032
            // Vin Max of the part >= Vin(max)
            qstr = common.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], 'max']); // 1033
            // Vout Max of the part >= Vout
            qstr = common.qsAddFilters(qstr, 5357, [selectedFilters['vout'], 'max']); // 1034
            // Switch Current of the part >= SwCrtMin and <= SwCrtMax
            qstr = common.qsAddFilters(qstr, 5358, [SwCrtMinSwregbig, SwCrtMaxSwregbig]); // 1035
            //Output Current of the part >= SwCrtMin and <= SwCrtMax
            qstr = common.qsAddFilters(qstr, 5349, [selectedFilters['iout'], OpCrtMaxSwregbig]); // 1107
            // Number of outputs > NOut
            if (NOut > 1) {
                qstr = common.qsAddFilters(qstr, 5351, [NOut, 'max']); // 2167
            }
        }
  
        /**
         * Inverter 1
         */
        if (Number(selectedFilters['vout']) < 0) {
            var intRippleSwregbig = 1.5;
            var intInvMultSwregbig = common.accMul(5, NOut);
  
            intInvMultSwregbig = common.accMul(intInvMultSwregbig, NOut);
            SwCrtMinSwregbig = common.accMul(common.accMul(intRippleSwregbig, common.accAdd(1, common.accDiv(Math.abs(Number(selectedFilters['vout'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout']));
            SwCrtMaxSwregbig = common.accMul(common.accMul(intRippleSwregbig, intInvMultSwregbig), common.accMul(common.accAdd(1, common.accDiv(Math.abs(Number(selectedFilters['vout'])), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout'])));
  
            if (SwCrtMaxSwregbig < .5) {
                SwCrtMaxSwregbig = .5;
            }
  
            if (SwCrtMaxSwregbig > 25) {
                SwCrtMaxSwregbig = 25;
            }
  
            SwCrtMaxSwregbig = common.sigFigs(SwCrtMaxSwregbig, 3);
            SwCrtMinSwregbig = common.sigFigs(SwCrtMinSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5362, "Inverting"); // 1646
            // Vin Min <= Vin(min)
            qstr = common.qsAddFilters(qstr, 5573, ['min', selectedFilters['vinmin']]); // 1032
            // Vin Max of the part >= Vin(max)
            qstr = common.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], 'max']); // 1033
            // Vout Max of the part >= Vout
            qstr = common.qsAddFilters(qstr, 5357, [Math.abs(selectedFilters['vout']), 'max']); // 1034
            // Vswitch Max of the part >= selectedFilters['vinmax'] - selectedFilters['vout']
            qstr = common.qsAddFilters(qstr, 5369, [(selectedFilters['vinmax'] - selectedFilters['vout']), 'max']); // 2086
            // Switch Current of the part >= SwCrtMin and <= SwCrtMax
            qstr = common.qsAddFilters(qstr, 5358, [SwCrtMinSwregbig, SwCrtMaxSwregbig]); // 1035
            // Number of outputs > NOut
            if (NOut > 1) {
                qstr = common.qsAddFilters(qstr, 5351, [NOut, 'max']); // 2167
            }
        }
  
        /**
         * buckBoost or Sepic 1
         */
        if (Number(selectedFilters['vout']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) > 0) {
            var intRippleSwregbig = 1.66;
            var intBBMultSwregbig = common.accMul(5, NOut);
            var intSwitchNeedSwregbig = common.accMul(common.accAdd(1, common.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout']));
  
            if (intSwitchNeedSwregbig < .5) {
                intBBMultSwregbig = common.accMul(intBBMultSwregbig, 2);
            } else if (intSwitchNeedSwregbig >= 4 && intSwitchNeedSwregbig <= 8) {
                intBBMultSwregbig = common.accMul(intBBMultSwregbig, 2);
            } else if (intSwitchNeedSwregbig >= 8) {
                intBBMultSwregbig = common.accMul(intBBMultSwregbig, 5);
            }
  
            SwCrtMinSwregbig = common.accMul(common.accMul(intRippleSwregbig, common.accAdd(1, common.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout']));
            SwCrtMaxSwregbig = common.accMul(common.accMul(intRippleSwregbig, intBBMultSwregbig), common.accMul(common.accAdd(1, common.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin']))), Number(selectedFilters['iout'])));
            OpCrtMaxSwregbig = common.accMul(intBBMultSwregbig, Number(selectedFilters['iout']));
            VswitchMaxSwregbig = common.accAdd(Number(selectedFilters['vinmax']), Number(selectedFilters['vout']));
  
            if (SwCrtMaxSwregbig < .5) {
                SwCrtMaxSwregbig = .5;
            }
            if (OpCrtMaxSwregbig < .25) {
                OpCrtMaxSwregbig = .25;
            }
            if (SwCrtMaxSwregbig > 60) {
                SwCrtMaxSwregbig = 60;
            }
            if (OpCrtMaxSwregbig > 25) {
                OpCrtMaxSwregbig = 25;
            }
  
            SwCrtMaxSwregbig = common.sigFigs(SwCrtMaxSwregbig, 3);
            SwCrtMinSwregbig = common.sigFigs(SwCrtMinSwregbig, 3);
            OpCrtMaxSwregbig = common.sigFigs(OpCrtMaxSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5362, ["Buck-Boost", "Sepic"]); // 1646
            // Vin Min <= Vin(min)
            qstr = common.qsAddFilters(qstr, 5573, ['min', selectedFilters['vinmin']]); // 1032
            // Vin Max of the part >= Vin(max)
            qstr = common.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], 'max']); // 1033
            // Vout Min of the part <= Vout Min
            qstr = common.qsAddFilters(qstr, 5347, ['min', selectedFilters['vout']]); // 1105
            // Vout Max of the part >= Vout
            qstr = common.qsAddFilters(qstr, 5357, [selectedFilters['vout'], 'max']); // 1034
            // Switch Current of the part >= SwCrtMin and <= SwCrtMax
            qstr = common.qsAddFilters(qstr, 5358, [SwCrtMinSwregbig, SwCrtMaxSwregbig]); // 1035
            //Output Current of the part >= Iout <= SwCrtMax
            qstr = common.qsAddFilters(qstr, 5349, [selectedFilters['iout'], OpCrtMaxSwregbig]); // 1107
            // Vswitch > Vin(max) + Vout (this should be greater, but will be greater or equal)
            qstr = common.qsAddFilters(qstr, 5369, [VswitchMaxSwregbig, 'max']); // 2086
            // Number of outputs > NOut
            if (NOut > 1) {
                qstr = common.qsAddFilters(qstr, 5351, [NOut, 'max']); // 2167
            }
        }
  
        /**
         * Buck 2
         */
        if (Number(selectedFilters['vout2']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout2']) > 0) {
            // Topology
            qstr = common.qsAddFilters(qstr, 5363, ["Buck", "LDO"]); // 2204
            // Vout Min of the part =< Vout
            qstr = common.qsAddFilters(qstr, 5372, ['min', selectedFilters['vout2']]); // 2202
            // Vout Max of the part >= Vout
            qstr = common.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], 'max']); // 2203
            // Output Current of the part >= Iout
            qstr = common.qsAddFilters(qstr, 5371, [selectedFilters['iout2'], 'max']); // 2148
        }
  
        /**
         * Boost 2
         */
        if (Number(selectedFilters['vout2']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout2']) > 0) {
            var intRippleSwregbig = 1.5;
            var intSwitchNeedSwregbig = common.accMul(common.accDiv(Number(selectedFilters['vout2']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout2']));
            SwCrtMinSwregbig = common.accMul(intRippleSwregbig, intSwitchNeedSwregbig);
            SwCrtMinSwregbig = common.sigFigs(SwCrtMinSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5363, "Boost"); // 2204
            // Vout Max of the part >= Vout
            qstr = common.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], 'max']); // 2203
            // Switch Current of the part >= SwCrtMin
            qstr = common.qsAddFilters(qstr, 5561, [SwCrtMinSwregbig, 'max']); // 2166
        }
  
        /**
         * Inverter 2
         */
        if (Number(selectedFilters['vout2']) < 0) {
            var intRippleSwregbig = 1.5;
            SwCrtMinSwregbig = common.accMul(common.accMul(intRippleSwregbig, common.accAdd(1, common.accDiv(Math.abs(Number(selectedFilters['vout2'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout2']));
            SwCrtMinSwregbig = common.sigFigs(SwCrtMinSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5363, "Inverting"); // 2204
            // Vout Max of the part >= abs(Vout)
            qstr = common.qsAddFilters(qstr, 5357, [Math.abs(Number(selectedFilters['vout2'])), 'max']); // 1034
            // Vswitch Max of the part >= selectedFilters['vinmax'] - selectedFilters['vout']
            qstr = common.qsAddFilters(qstr, 5369, [(Number(selectedFilters['vinmax']) - Number(selectedFilters['vout2'])), 'max']); // 2086
            // Switch Current of the part >= SwCrtMin
            qstr = common.qsAddFilters(qstr, 5561, [SwCrtMinSwregbig, 'max']); // 2166
        }
  
        /**
         * buckBoost or Sepic 2
         */
        if (Number(selectedFilters['vout2']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout2']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout2']) > 0) {
            var intRippleSwregbig = 1.5;
            SwCrtMinSwregbig = common.accMul(common.accMul(intRippleSwregbig, common.accAdd(1, common.accDiv(Number(selectedFilters['vout2']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout2']));
            SwCrtMinSwregbig = common.sigFigs(SwCrtMinSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5363, ["Buck-Boost", "Sepic"]); // 2204
            // Vout Min of the part <= Vout Min
            qstr = common.qsAddFilters(qstr, 5372, ['min', selectedFilters['vout2']]); // 2202
            // Vout Max of the part >= Vout Max
            qstr = common.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], 'max']); // 2203
            //Switch Current of the part >= SwCrtMin
            qstr = common.qsAddFilters(qstr, 5561, [SwCrtMinSwregbig, 'max']); // 2166
            // Output Current of the part >= SwCrtMin
            qstr = common.qsAddFilters(qstr, 5371, [selectedFilters['iout'], 'max']); // 2148
        }
  
        /**
         * Buck 3
         */
        if (Number(selectedFilters['vout3']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout3']) > 0) {
            // Topology
            qstr = common.qsAddFilters(qstr, 5377, ["Buck", "LDO"]); // 2267
            // Vout Min of the part =< Vout
            qstr = common.qsAddFilters(qstr, 5375, ['min', selectedFilters['vout3']]); // 2264
            // Vout Max of the part >= Vout
            qstr = common.qsAddFilters(qstr, 5376, [selectedFilters['vout3'], 'max']); // 2265
            // Output Current of the part >= Iout
            qstr = common.qsAddFilters(qstr, 5373, [selectedFilters['iout3'], 'max']); // 2189
        }
  
        /**
         * Boost 3
         */
        if (Number(selectedFilters['vout3']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout3']) > 0) {
  
            var intRippleSwregbig = 1.5;
            var intSwitchNeedSwregbig = common.accMul(common.accDiv(Number(selectedFilters['vout3']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout3']));
            SwCrtMinSwregbig = common.accMul(intRippleSwregbig, intSwitchNeedSwregbig);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5377, "Boost"); // 2267
            // Vout Max of the part >= Vout
            qstr = common.qsAddFilters(qstr, 5376, [selectedFilters['vout3'], 'max']); // 2265
            // Switch Current of the part >= SwCrtMin
            qstr = common.qsAddFilters(qstr, 5562, [SwCrtMinSwregbig, 'max']); // 2191
        }
  
        /**
         * Inverter 3
         */
        if (Number(selectedFilters['vout3']) < 0) {
            var intRippleSwregbig = 1.5;
            SwCrtMinSwregbig = common.accMul(common.accMul(intRippleSwregbig, common.accAdd(1, common.accDiv(Math.abs(Number(selectedFilters['vout3'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout3']));
            SwCrtMinSwregbig = common.sigFigs(SwCrtMinSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5377, "Inverting"); // 2267
            // Vout Max of the part >= abs(Vout)
            qstr = common.qsAddFilters(qstr, 5376, [Math.abs(Number(selectedFilters['vout3'])), 'max']); // 2265
            // Vswitch Max of the part >= selectedFilters['vinmax'] - selectedFilters['vout']
            qstr = common.qsAddFilters(qstr, 5369, [(Number(selectedFilters['vinmax']) - Number(selectedFilters['vout3'])), 'max']); // 2086
            // Switch Current of the part >= SwCrtMin
            qstr = common.qsAddFilters(qstr, 5562, [SwCrtMinSwregbig, 'max']); // 2191
        }
  
        /**
         * buckBoost or Sepic 3
         */
        if (Number(selectedFilters['vout3']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout3']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout3']) > 0) {
            var intRippleSwregbig = 1.5;
            SwCrtMinSwregbig = common.accMul(common.accMul(intRippleSwregbig, common.accAdd(1, common.accDiv(Number(selectedFilters['vout3']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout3']));
            SwCrtMinSwregbig = common.sigFigs(SwCrtMinSwregbig, 3);
  
            // Topology
            qstr = common.qsAddFilters(qstr, 5377, ["Buck-Boost", "Sepic"]); // 2267
            // Vout Min of the part <= Vout Min
            qstr = common.qsAddFilters(qstr, 5375, ['min', selectedFilters['vout3']]); // 2264
            // Vout Max of the part >= Vout Max
            qstr = common.qsAddFilters(qstr, 5376, [selectedFilters['vout3'], 'max']); // 2265
            // Switch Current of the part >= SwCrtMin
            qstr = common.qsAddFilters(qstr, 5562, [SwCrtMinSwregbig, 'max']); // 2191
            //Output Current of the part >= SwCrtMin 
            qstr = common.qsAddFilters(qstr, 5373, [selectedFilters['iout3'], 'max']); // 2189
        }
  
  
        if (addedColumns !== null && Array.isArray(addedColumns) && addedColumns.length > 0){
                qstr = window._qfCommon.qsAddColumns(qstr, addedColumns);
        }
        return qstr;
        
        break;
                
      case "umodregbig":
        let outMaxUmodregbig, SwCrtMinUmodregbig;
  
        if (selectedFilters['lowemi'] === 'on') {    //low emi
          //qstr += "!5576_Low EMI";
          qstr = window._qfCommon.qsAddFilters(qstr, 5576, "Low EMI");
        } else if (selectedFilters['ultrathin'] === 'on') {  //ultrathin
            //qstr += "!s17_<2";
            qstr = window._qfCommon.qsAddFilters(qstr, "s17", ["min", 2]);
        }
  
        if (selectedFilters['heatsink'] === 'on') {   //heat sink
            //qstr += "!5576_Internal Heat Sink";
            qstr = window._qfCommon.qsAddFilters(qstr, 5576, "Internal Heat Sink");
        }
  
  
        if (selectedFilters['iout']) {
            var NOut = 1;
        }
        if (selectedFilters['iout2']) {
            var NOut = 2;
        }
        if (selectedFilters['iout3']) {
            var NOut = 3;
        }
  
        // Buck 1
        if (Number(selectedFilters['vout']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) > 0) {
  
            var intBuckMultUmodregbig = window._qfCommon.accMul(1.5, NOut);
  
            if (Number(selectedFilters['iout']) <= .1) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 2);
            } else if (Number(selectedFilters['iout']) <= 5) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 1);
            } else if (Number(selectedFilters['iout']) <= 40) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 1.5);
            } else if (Number(selectedFilters['iout']) <= 500) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 2);
            }
  
            if (Number(selectedFilters['vinmax']) <= 5.5) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 1);
            } else if (Number(selectedFilters['vinmax']) <= 12) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 1);
            } else if (Number(selectedFilters['vinmax']) <= 36) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 1);
            } else if (Number(selectedFilters['vinmax']) <= 60) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 1.5);
            } else if (Number(selectedFilters['vinmax']) > 60) {
                intBuckMultUmodregbig = window._qfCommon.accMul(intBuckMultUmodregbig, 5);
            }
  
            outMaxUmodregbig = window._qfCommon.accMul(Number(selectedFilters['iout']), intBuckMultUmodregbig);
  
            if (outMaxUmodregbig < .025) {
                outMaxUmodregbig = .025;
            }
  
            if (outMaxUmodregbig > 240) {
                outMaxUmodregbig = 240;
            }
  
            outMaxUmodregbig = window._qfCommon.sigFigs(outMaxUmodregbig, 3);
  
            //topology
            //qstr += "!5362_Buck";
            qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Buck");
  
            //Vin Min <= Vin(min)
            //qstr += "!5573_<=" + selectedFilters['vinmin'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
            //Vin Max of the part >= Vin(max)
            //qstr += "!5574_>=" + selectedFilters['vinmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
            //Vout Min of the part =< Vout
            //qstr += "!5347_<=" + selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5347, ["min", selectedFilters['vout']]);
  
            //Vout Max of the part >= Vout
            //qstr += "!5357_>=" + selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
            //Output Current of the part >= Iout and <= Iout * intBuckMult
            //qstr += "!5349_" + selectedFilters['iout'] + ":" + outMax;
            qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], outMaxUmodregbig]);
  
            //Number of outputs > NOut
            if (NOut > 1) {
                //qstr += "!5351_>=" + NOut;
                qstr = window._qfCommon.qsAddFilters(qstr, 5351, [NOut, "max"]);
            }
  
        }
  
        //Boost 1
        if (Number(selectedFilters['vout']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) > 0) {
            var intRippleUmodregbig = 1.5;
            var intSwitchNeedUmodregbig = window._qfCommon.accMul(window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout']));
            SwCrtMinUmodregbig = window._qfCommon.accMul(intRippleUmodregbig, intSwitchNeedUmodregbig);
            SwCrtMinUmodregbig = window._qfCommon.sigFigs(SwCrtMinUmodregbig, 3);
  
            //topology
            //qstr += "!5362_Boost";
            qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Boost");
  
            //Vin Min <= Vin(min)
            //qstr += "!5573_<=" + selectedFilters['vinmin'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
            //Vin Max of the part >= Vin(max)
            //qstr += "!5574_>=" + selectedFilters['vinmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
            //Vout Max of the part >= Vout
            //qstr += "!5357_>=" + selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5358_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMinUmodregbig, "max"]);
        }
  
        //Inverter 1
        if (Number(selectedFilters['vout']) < 0) {
            var intRippleUmodregbig = 1.5;
            SwCrtMinUmodregbig = window._qfCommon.accMul(window._qfCommon.accMul(intRippleUmodregbig, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Math.abs(Number(selectedFilters['vout'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout']));
            SwCrtMinUmodregbig = window._qfCommon.sigFigs(SwCrtMinUmodregbig, 3);
  
            //topology
            //qstr += "!5362_Inverting";
            qstr = window._qfCommon.qsAddFilters(qstr, 5362, "Inverting");
  
            //Vin Min <= Vin(min)
            //qstr += "!5573_<=" + selectedFilters['vinmin'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
            //Vin Max of the part >= Vin(max)
            //qstr += "!5574_>=" + selectedFilters['vinmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
            //Vout Max of the part >= abs(Vout)
            //qstr += "!5357_>=" + Math.abs(selectedFilters['vout']);
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [Math.abs(selectedFilters['vout']), "max"]);
  
            //Vswitch Max of the part >= selectedFilters['vinmax'] - selectedFilters['vout']
            //qstr += "!5369_>=" + (selectedFilters['vinmax'] - selectedFilters['vout']);
            qstr = window._qfCommon.qsAddFilters(qstr, 5369, [selectedFilters['vinmax'] - selectedFilters['vout'], "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5358_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMinUmodregbig, "max"]);
        }
  
        //buckBoost or Sepic 1
        if (Number(selectedFilters['vout']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout']) > 0) {
            var intRippleUmodregbig = 1.5;
            SwCrtMinUmodregbig = window._qfCommon.accMul(window._qfCommon.accMul(intRippleUmodregbig, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Number(selectedFilters['vout']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout']));
            SwCrtMinUmodregbig = window._qfCommon.sigFigs(SwCrtMinUmodregbig, 3);
  
            //topology
            //qstr += "!5362_buckBoost|Sepic";
            qstr = window._qfCommon.qsAddFilters(qstr, 5362, ["Buck-Boost", "Buck", "Sepic"]);
  
            //Vin Min <= Vin(min)
            //qstr += "!5573_<=" + selectedFilters['vinmin'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5573, ["min", selectedFilters['vinmin']]);
  
            //Vin Max of the part >= Vin(max)
            //qstr += "!5574_>=" + selectedFilters['vinmax'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5574, [selectedFilters['vinmax'], "max"]);
  
            //Vout Min of the part <= Vout Min
            //qstr += "!5347_<=" + selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5347, ["min", selectedFilters['vout']]);
  
            //Vout Max of the part >= Vout Max
            //qstr += "!5357_>=" + selectedFilters['vout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [selectedFilters['vout'], "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5358_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5358, [SwCrtMinUmodregbig, "max"]);
  
            //Output Current of the part >= SwCrtMin
            //qstr += "!5349_>=" + selectedFilters['iout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5349, [selectedFilters['iout'], "max"]);
        }
  
        // Buck 2
        if (Number(selectedFilters['vout2']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout2']) > 0) {
  
            //topology
            //qstr += "!5363_Buck|LDO";
            qstr = window._qfCommon.qsAddFilters(qstr, 5363, ["Buck", "LDO"]);
  
            //Vout Min of the part =< Vout
            //qstr += "!5372_<=" + selectedFilters['vout2'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5372, ["min", selectedFilters['vout2']]);
  
            //Vout Max of the part >= Vout
            //qstr += "!5374_>=" + selectedFilters['vout2'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], "max"]);
  
            //Output Current of the part >= Iout
            //qstr += "!5371_>=" + selectedFilters['iout2'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5371, [selectedFilters['iout2'], "max"]);
        }
  
        //Boost 2
        if (Number(selectedFilters['vout2']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout2']) > 0) {
            var intRippleUmodregbig = 1.5;
            var intSwitchNeedUmodregbig = window._qfCommon.accMul(window._qfCommon.accDiv(Number(selectedFilters['vout2']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout2']));
            SwCrtMinUmodregbig = window._qfCommon.accMul(intRippleUmodregbig, intSwitchNeedUmodregbig);
            SwCrtMinUmodregbig = window._qfCommon.sigFigs(SwCrtMinUmodregbig, 3);
  
            //topology
            //qstr += "!5363_Boost";
            qstr = window._qfCommon.qsAddFilters(qstr, 5363, "Boost");
  
            //Vout Max of the part >= Vout
            //qstr += "!5374_>=" + selectedFilters['vout2'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5561_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5561, [SwCrtMinUmodregbig, "max"]);
        }
  
        //Inverter 2
        if (Number(selectedFilters['vout2']) < 0) {
            var intRippleUmodregbig = 1.5;
            SwCrtMinUmodregbig = window._qfCommon.accMul(window._qfCommon.accMul(intRippleUmodregbig, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Math.abs(Number(selectedFilters['vout2'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout2']));
            SwCrtMinUmodregbig = window._qfCommon.sigFigs(SwCrtMinUmodregbig, 3);
  
            //topology
            //qstr += "!5363_Inverting";
            qstr = window._qfCommon.qsAddFilters(qstr, 5363, "Inverting");
  
            //Vout Max of the part >= abs(Vout)
            //qstr += "!5357_>=" + Math.abs(selectedFilters['vout2']);
            qstr = window._qfCommon.qsAddFilters(qstr, 5357, [Math.abs(selectedFilters['vout2']), "max"]);
  
            //Vswitch Max of the part >= selectedFilters['vinmax'] - selectedFilters['vout']
            //qstr += "!5369_>=" + (selectedFilters['vinmax'] - selectedFilters['vout2']);
            qstr = window._qfCommon.qsAddFilters(qstr, 5369, [Number(selectedFilters['vinmax']) - Number(selectedFilters['vout2']), "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5561_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5561, [SwCrtMinUmodregbig, "max"]);
        }
  
        //buckBoost or Sepic 2
        if (Number(selectedFilters['vout2']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout2']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout2']) > 0) {
            var intRippleUmodregbig = 1.5;
            SwCrtMinUmodregbig = window._qfCommon.accMul(window._qfCommon.accMul(intRippleUmodregbig, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Number(selectedFilters['vout2']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout2']));
            SwCrtMinUmodregbig = window._qfCommon.sigFigs(SwCrtMinUmodregbig, 3);
  
            //topology
            //qstr += "!5363_buckBoost|Sepic";
            qstr = window._qfCommon.qsAddFilters(qstr, 5363, ["Buck-Boost", "Sepic"]);
  
            //Vout Min of the part <= Vout Min
            //qstr += "!5372_<=" + selectedFilters['vout2'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5372, ["min", selectedFilters['vout2']]);
  
            //Vout Max of the part >= Vout Max
            //qstr += "!5374_>=" + selectedFilters['vout2'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5374, [selectedFilters['vout2'], "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5561_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5561, [SwCrtMinUmodregbig, "max"]);
  
            //Output Current of the part >= SwCrtMin
            //qstr += "!5371_>=" + selectedFilters['iout'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5371, [selectedFilters['iout'], "max"]);
        }
  
        // Buck 3
        if (Number(selectedFilters['vout3']) < Number(selectedFilters['vinmin']) && Number(selectedFilters['vout3']) > 0) {
  
            //topology
            //qstr += "!5377_Buck|LDO";
            qstr = window._qfCommon.qsAddFilters(qstr, 5377, ["Buck", "LDO"]);
  
            //Vout Min of the part =< Vout
            //qstr += "!5375_<=" + selectedFilters['vout3'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5375, ["min", selectedFilters['vout3']]);
  
            //Vout Max of the part >= Vout
            //qstr += "!5376_>=" + selectedFilters['vout3'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5376, [selectedFilters['vout3'], "max"]);
  
            //Output Current of the part >= Iout
            //qstr += "!5373_>=" + selectedFilters['iout3'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5373, [selectedFilters['iout3'], "max"]);
        }
  
        //Boost 3
        if (Number(selectedFilters['vout3']) > Number(selectedFilters['vinmax']) && Number(selectedFilters['vout3']) > 0) {
  
            var intRippleUmodregbig = 1.5;
            var intSwitchNeedUmodregbig = window._qfCommon.accMul(window._qfCommon.accDiv(Number(selectedFilters['vout3']), Number(selectedFilters['vinmin'])), Number(selectedFilters['iout3']));
            SwCrtMinUmodregbig = window._qfCommon.accMul(intRippleUmodregbig, intSwitchNeedUmodregbig);
  
            //topology
            //qstr += "!5377_Boost";
            qstr = window._qfCommon.qsAddFilters(qstr, 5377, "Boost");
  
            //Vout Max of the part >= Vout
            //qstr += "!5376_>=" + selectedFilters['vout3'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5376, [selectedFilters['vout3'], "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5562_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5562, [SwCrtMinUmodregbig, "max"]);
        }
  
        //Inverter 3
        if (Number(selectedFilters['vout3']) < 0) {
            var intRippleUmodregbig = 1.5;
            SwCrtMinUmodregbig = window._qfCommon.accMul(window._qfCommon.accMul(intRippleUmodregbig, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Math.abs(Number(selectedFilters['vout3'])), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout3']));
            SwCrtMinUmodregbig = window._qfCommon.sigFigs(SwCrtMinUmodregbig, 3);
  
            //topology
            qstr += "!5377_Inverting";
            //qstr = window._qfCommon.qsAddFilters(qstr, 5377, "Inverting");
  
            //Vout Max of the part >= abs(Vout)
            qstr += "!5376_>=" + Math.abs(Number(selectedFilters['vout3']));
            //qstr = window._qfCommon.qsAddFilters(qstr, 5376, [Math.abs(selectedFilters['vout3']), "max"]);
  
            //Vswitch Max of the part >= selectedFilters['vinmax'] - selectedFilters['vout']
            //qstr += "!5369_>=" + (selectedFilters['vinmax'] - selectedFilters['vout3']);
            qstr = window._qfCommon.qsAddFilters(qstr, 5369, [Number(selectedFilters['vinmax']) - Number(selectedFilters['vout3']), "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5562_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5562, [SwCrtMinUmodregbig, "max"]);
        }
  
        //buckBoost or Sepic 3
        if (Number(selectedFilters['vout3']) >= Number(selectedFilters['vinmin']) && Number(selectedFilters['vout3']) <= Number(selectedFilters['vinmax']) && Number(selectedFilters['vout3']) > 0) {
            var intRippleUmodregbig = 1.5;
            SwCrtMinUmodregbig = window._qfCommon.accMul(window._qfCommon.accMul(intRippleUmodregbig, window._qfCommon.accAdd(1, window._qfCommon.accDiv(Number(selectedFilters['vout3']), Number(selectedFilters['vinmin'])))), Number(selectedFilters['iout3']));
            SwCrtMinUmodregbig = window._qfCommon.sigFigs(SwCrtMin, 3);
  
            //topology
            //qstr += "!5377_buckBoost|Sepic";
            qstr = window._qfCommon.qsAddFilters(qstr, 5377, ["Buck-Boost", "Sepic"]);
  
            //Vout Min of the part <= Vout Min
            //qstr += "!5375_<=" + selectedFilters['vout3'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5375, ["min", selectedFilters['vout3']]);
  
            //Vout Max of the part >= Vout Max
            //qstr += "!5376_>=" + selectedFilters['vout3'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5376, [selectedFilters['vout3'], "max"]);
  
            //Switch Current of the part >= SwCrtMin
            //qstr += "!5562_>=" + SwCrtMin;
            qstr = window._qfCommon.qsAddFilters(qstr, 5562, [SwCrtMinUmodregbig, "max"]);
  
            //Output Current of the part >= SwCrtMin 
            //qstr += "!5373_>=" + selectedFilters['iout3'];
            qstr = window._qfCommon.qsAddFilters(qstr, 5373, [selectedFilters['iout3'], "max"]);
        }
        if (addedColumns !== null && Array.isArray(addedColumns) && addedColumns.length > 0){
                qstr = window._qfCommon.qsAddColumns(qstr, addedColumns);
        }
        return qstr;
        break;
                                
      default: //Unknown validation option, exit.
      return;
      }
  };
//#endregion